import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ErrorUtils} from '../utils/Utils';
import {TranslateService} from './translate.service';

export interface SnackbarConfig {
  message: string;
  duration?: number;
  action?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackbarSubject = new BehaviorSubject<SnackbarConfig | null>(null);

  // Resolved lazily: AuthService -> SnackbarService -> TranslateService -> AppStateService -> AuthService
  // would otherwise be a DI cycle
  constructor(private injector: Injector) {}

  private get translate(): TranslateService {
    return this.injector.get(TranslateService);
  }

  observeSnackbar(): Observable<SnackbarConfig | null> {
    return this.snackbarSubject;
  }

  showMessage(message: string, duration: number = 3000, action: string = 'Close') {
    // Our own messages are Swedish source strings; a server or unknown message passes through unchanged
    this.snackbarSubject.next({
      message: this.translate.single(message),
      duration,
      action
    });
  }

  showMessageForError(error: any, duration: number = 10000, action: string = 'Close') {
    const message = this.translate.single(ErrorUtils.getErrorMessage(error));
    this.snackbarSubject.next({
      message,
      duration,
      action
    });
  }

  dismiss() {
    this.snackbarSubject.next(null);
  }
}


